const stateDefault =  false;

export default (state = stateDefault, action) => {
  switch (action.type){
    case 'LOADING_SHOW':
      return action.showing ;
    default:
      return state;
  }
};
